/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React, { useEffect, useState, useRef } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import AuthGuard from "components/AuthGuard";

import { Box, Card, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import MDButton from "components/MDButton";
// eslint-disable-next-line import/order
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources, siteData } from "../../authConfig";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

// css file
import "./Taxonomy.css";
import { useNavigate } from "react-router-dom";
// import Skeleton from "react-loading-skeleton";
// edit button
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// alert box
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleIcon from "@mui/icons-material/People";
import { useCurrentUser } from "context/UserContext";
import DelegationDialog from "./DelegationDialog";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 13,
  },
}));
// ID13/ID139 — resolve a subcategory's appetite → its configured level (colour + order), with
// legacy aliases + a rank/colour fallback so old data still displays and sorts correctly.
const APPETITE_ALIAS = {
  "risk aversion": "risk aversion",
  "risk averse": "risk aversion",
  "balanced risk aversion": "balanced risk aversion",
  "risk balanced": "balanced risk aversion",
  "balanced opportunity": "balanced opportunity",
  opportunity: "opportunity seeking",
  "opportunity seeking": "opportunity seeking",
  "risk seeking": "opportunity seeking",
};
const APPETITE_RANK = {
  "risk aversion": 0,
  "balanced risk aversion": 1,
  "balanced opportunity": 2,
  "opportunity seeking": 3,
};
const APPETITE_COLOR_FALLBACK = {
  "risk aversion": "#d32f2f",
  "balanced risk aversion": "#f57c00",
  "balanced opportunity": "#fbc02d",
  "opportunity seeking": "#388e3c",
};

function TaxonomyOverview() {
  const { error, execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });
  const { user, role, isRiskAdmin } = useCurrentUser();
  const userEmail = (user?.email || user?.preferred_username || "").toLowerCase();
  // SUPER_RISK_ADMIN is a superset of RISK_ADMIN — treat both as admin (isRiskAdmin covers both).
  const isAdmin = isRiskAdmin;
  const isViewOnly = role === "VIEW";

  const [allData, setAllData] = useState(null);
  const [ownerUsers, setOwnerUsers] = useState([]);
  // ID13/ID139 — configured appetite levels drive the colour + sort order in the overview.
  const [appetiteLevels, setAppetiteLevels] = useState([]);
  const appetiteFetched = useRef(false);
  const appetiteInfo = (value) => {
    const raw = String(value || "").trim();
    if (!raw) return { order: 99, color: "", title: "" };
    const lower = raw.toLowerCase();
    let lvl = appetiteLevels.find((l) => String(l.title || "").toLowerCase() === lower);
    if (!lvl) {
      const alias = APPETITE_ALIAS[lower];
      if (alias) lvl = appetiteLevels.find((l) => String(l.title || "").toLowerCase() === alias);
    }
    if (lvl) {
      return {
        order: typeof lvl.order === "number" ? lvl.order : 99,
        color: lvl.color || "",
        title: lvl.title || raw,
      };
    }
    const canon = APPETITE_ALIAS[lower] || lower;
    return {
      order: APPETITE_RANK[canon] != null ? APPETITE_RANK[canon] : 99,
      color: APPETITE_COLOR_FALLBACK[canon] || "#cfd8dc",
      title: raw,
    };
  };
  const [delegationOpen, setDelegationOpen] = useState(false);
  const [delegationCategory, setDelegationCategory] = useState(null);
  const [noData, setNoData] = useState(false);
  const taxonomyListFetched = useRef(false);
  const ownerUsersFetched = useRef(false);

  useEffect(() => {
    if (!ownerUsersFetched.current) {
      ownerUsersFetched.current = true;
      execute("GET", `${protectedResources.apiTodoList.endpoint}/users/list-for-owners`).then(
        (response) => {
          if (response?.data && Array.isArray(response.data)) {
            setOwnerUsers(response.data);
          }
        }
      );
    }
    // ID13/ID139 — appetite levels for colour + sort.
    if (!appetiteFetched.current) {
      appetiteFetched.current = true;
      execute("GET", `${protectedResources.apiTodoList.endpoint}/appetite-levels/config`)
        .then((res) => {
          const lv = (res?.data?.levels || res?.levels || [])
            .slice()
            .sort((a, b) => (a.order || 0) - (b.order || 0));
          if (lv.length) setAppetiteLevels(lv);
        })
        .catch(() => {});
    }
  }, [execute]);

  const getOwnerDisplayName = (ownerEmail) => {
    if (!ownerEmail) return "";
    const u = ownerUsers.find(
      (x) => (x.email || "").toLowerCase() === String(ownerEmail).toLowerCase()
    );
    if (!u) return ownerEmail;
    const first = u.firstName || "";
    const last = u.lastName || "";
    if (first || last) return [first, last].filter(Boolean).join(" ").trim();
    return u.name || u.email || ownerEmail;
  };

  useEffect(() => {
    if (taxonomyListFetched.current || allData) return;
    taxonomyListFetched.current = true;
    execute("GET", `${protectedResources.apiTodoList.endpoint}/taxonomy/list`)
      .then((response) => {
        if (response?.success === true && Array.isArray(response?.data)) {
          if (response.data.length > 0) setAllData(response.data);
          else setNoData(true);
        }
      })
      .catch(() => {});
  }, [execute, allData]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const [SingleTaxonomy, setSingleTaxonomy] = useState(null);

  useEffect(() => {
    if (allData && allData.length) {
      setSingleTaxonomy(allData[0]);
    }
  }, [allData]);

  const navigate = useNavigate();
  const [Dialogopen, setOpen] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // handle card click
  const handleCardClick = (categoryId) => {
    // Store the category ID in an object or perform other actions
    setSelectedCategoryId(categoryId);
    setOpen(true);
  };
  // navigate on card click
  const handleEditConfirmation = () => {
    setOpen(false);
    const categoryId = selectedCategoryId;
    const taxonomyId = SingleTaxonomy.id;
    if (selectedCategoryId) {
      // Perform actions when the user confirms (e.g., navigate to edit page)

      if (selectedCategoryId) {
        navigate("/configure", { state: { categoryId, taxonomyId } });
      }
    } else {
      navigate("/configure", { state: { taxonomyId } });
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  // navigate on add category
  const handleAddCategory = () => {
    // const taxonomyId = SingleTaxonomy.id;
    setOpen(true);

    // navigate("/configure", { state: { taxonomyId } });
  };
  // navigate to add taxonomy
  const handleAddTaxonomy = () => {
    const categoryId = null;
    const taxonomyId = null;
    navigate("/configure", { state: { categoryId, taxonomyId } });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const id = open ? "simple-popover" : undefined;
  // const [loading, setLoading] = useState(isLoading);

  return (
    <>
      <DelegationDialog
        open={delegationOpen}
        onClose={() => setDelegationOpen(false)}
        category={delegationCategory}
        taxonomyId={SingleTaxonomy?.id}
        userEmail={userEmail}
        isAdmin={isAdmin}
        isCategoryOwner={role === "CATEGORY_OWNER"}
        onSaved={() => {}}
      />
      <Dialog open={Dialogopen} onClose={handleCloseDialog}>
        <DialogTitle
          sx={{
            color: "red", // Set the color to red
            fontWeight: "bold", // Set the font weight to bold
          }}
        >
          Alert!
        </DialogTitle>
        <DialogContent>
          Are you sure ? Editing Category and Sub Category will re-classify the previously
          classified records. This action is not recommended unless it is justified and approved by
          the senior management.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditConfirmation} color="primary">
            Yes
          </Button>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <>
        {noData ? (
          <Grid
            container
            // spacing={1}
            // justifyContent="space-between"
            className="Taxonomy-overview"
            style={{
              backgroundColor: "white",
              borderRadius: "2px",
              padding: "15px",
            }}
          >
            <Grid item md={12} lg={12} sx={{ mb: "7px" }}>
              <Stack
                direction="row"
                sx={{ display: "flex", justifyContent: "space-between", mb: "7px" }}
              >
                {!isViewOnly && (
                  <MDButton
                    variant="contained"
                    BackgroundColor="#402899"
                    color="#402899"
                    sx={{
                      color: "#f7f4fb",
                      width: "156px",
                      height: " fit-content",
                      mr: "15px",
                    }}
                    className="add-button"
                    onClick={() => handleAddTaxonomy()}
                  >
                    Add Taxonomy
                  </MDButton>
                )}
              </Stack>
              <hr className="hr-horizontal" />

              <Grid container columns={{ xs: 3, sm: 8, md: 12 }} sx={{ minHeight: "420px" }}>
                <Grid sx={{ minHeight: "375px" }}>
                  <Typography>No Category Present </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            className="Taxonomy-overview"
            style={{
              backgroundColor: "white",
              borderRadius: "2px",
              padding: "15px 8px 15px 15px",
            }}
          >
            <Grid item md={12} lg={12} sx={{ mb: "7px", width: "100%", maxWidth: "100%" }}>
              <Stack
                direction="row"
                sx={{ display: "flex", justifyContent: "space-between", mb: "7px" }}
              >
                <Stack direction="column">
                  {SingleTaxonomy ? (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <MDTypography>{SingleTaxonomy && SingleTaxonomy.name}</MDTypography>
                      {SingleTaxonomy.status === "draft" && (
                        <Box
                          component="span"
                          sx={{
                            px: "8px",
                            py: "2px",
                            borderRadius: "4px",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            bgcolor: "#fff3e0",
                            color: "#e65100",
                            border: "1px solid #ffb74d",
                          }}
                        >
                          DRAFT
                        </Box>
                      )}
                    </Stack>
                  ) : (
                    <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={230} height={40} />
                  )}
                  {SingleTaxonomy ? (
                    <MDTypography fontWeight="light" fontSize={13}>
                      {SingleTaxonomy && SingleTaxonomy.description}
                    </MDTypography>
                  ) : (
                    <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={230} height={20} />
                  )}
                </Stack>
                {/* {allData && allData.length > 0 ? (
                <MDButton
                  variant="contained"
                  BackgroundColor="#52009b"
                  color="#52009b"
                  sx={{
                    color: "#f7f4fb",
                    width: "16%",
                    height: " fit-content",
                    mr: " 15px",
                  }}
                  className="add-button"
                  onClick={() => handleAddCategory()}
                >
                  Edit Taxonomy
                </MDButton>
              ) : (
                <MDButton
                  variant="contained"
                  BackgroundColor="#52009b"
                  color="#52009b"
                  sx={{
                    color: "#f7f4fb",
                    width: "16%",
                    height: " fit-content",
                    mr: " 15px",
                  }}
                  className="add-button"
                  onClick={() => handleAddTaxonomy()}
                >
                  Add Taxonomy
                </MDButton>
              )} */}
                {!isViewOnly &&
                  (allData ? (
                    <MDButton
                      variant="contained"
                      BackgroundColor="#52009b"
                      color="#52009b"
                      sx={{
                        color: "#f7f4fb",
                        width: "156px",
                        height: " fit-content",
                        mr: " 15px",
                      }}
                      className="add-button"
                      onClick={() => handleAddCategory()}
                    >
                      Edit Taxonomy
                    </MDButton>
                  ) : (
                    <Skeleton variant="rectangular" width={155} height={40} />
                  ))}
              </Stack>
              <hr className="hr-horizontal" />

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)",
                    lg: "repeat(4, 1fr)",
                  },
                  gap: "2px 12px",
                  minHeight: "420px",
                  width: "100%",
                }}
              >
                {SingleTaxonomy ? (
                  SingleTaxonomy.Categories &&
                  SingleTaxonomy.Categories.map((category, categoryIndex) => (
                    <Card
                      key={category.id || categoryIndex}
                      sx={{
                        bgcolor: "background.paper",
                        boxShadow: 2,
                        borderRadius: 2,
                        height: 290,
                        minWidth: 0,
                        // maxHeight: 200,
                        // overflow: "auto", // Add overflow property to enable scrolling
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          padding: "4px",
                          justifyContent: "space-evenly",
                          minHeight: "50px",
                          position: "sticky",
                          backgroundColor: "#F7F8FF",
                        }}
                      >
                        <div style={{ width: "35px", alignItems: "center", display: "flex" }}>
                          <AccountCircleOutlinedIcon
                            style={{ fontSize: "40px", color: "#402899" }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#402899",
                              lineHeight: "1.3",
                            }}
                          >
                            {category.name}
                          </span>
                          {category.Owner && (
                            <Typography variant="caption" sx={{ color: "#666", fontSize: "11px" }}>
                              {getOwnerDisplayName(category.Owner)}
                            </Typography>
                          )}
                        </div>
                        <LightTooltip
                          title={category.desc || category.definition || "No definition"}
                        >
                          <InfoOutlinedIcon onClick={handleClick} sx={{ color: "#402899" }} />
                        </LightTooltip>
                        {(isAdmin || role === "CATEGORY_OWNER") && (
                          <LightTooltip title="Manage delegates">
                            <PeopleIcon
                              style={{
                                cursor: "pointer",
                                paddingLeft: "4px",
                                color: "#402899",
                                fontSize: 20,
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setDelegationCategory(category);
                                setDelegationOpen(true);
                              }}
                            />
                          </LightTooltip>
                        )}
                        {!isViewOnly && (
                          <LightTooltip title="Edit category">
                            <ModeEditOutlineOutlinedIcon
                              style={{ cursor: "pointer", paddingLeft: "4px", color: "#402899" }}
                              onClick={() => handleCardClick(category.id)}
                            />
                          </LightTooltip>
                        )}
                      </div>

                      <Divider sx={{ ml: "5px", mr: "5px" }} />

                      {/* <hr /> */}
                      <div
                        style={{
                          marginLeft: "7px",
                          overflow: "auto", // Add overflow property to enable scrolling for the content below
                          // height: "85%", // Set a fixed height for the scrollable content
                          lineHeight: 1.2,
                        }}
                      >
                        {category.SubCategories &&
                          [...category.SubCategories]
                            // ID13 — risk-averse at top → opportunity-seeking at bottom.
                            .sort(
                              (a, b) =>
                                appetiteInfo(a.Appetite).order - appetiteInfo(b.Appetite).order ||
                                String(a.name || "").localeCompare(String(b.name || ""))
                            )
                            .map((subCats, subCategoryIndex) => {
                              const ai = appetiteInfo(subCats.Appetite);
                              return (
                                <React.Fragment key={subCats.id || subCategoryIndex}>
                                  <LightTooltip
                                    title={
                                      subCats.Description || subCats.definition || "No definition"
                                    }
                                  >
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        fontSize: "14px",
                                        lineHeight: "1.9",
                                        cursor: "help",
                                      }}
                                    >
                                      {/* ID139 — appetite colour dot */}
                                      <span
                                        style={{
                                          width: 9,
                                          height: 9,
                                          borderRadius: "50%",
                                          background: ai.color || "#cfd8dc",
                                          flexShrink: 0,
                                          display: "inline-block",
                                        }}
                                      />
                                      {subCats.name}
                                      {ai.title ? (
                                        <span style={{ color: "#9e9e9e", fontSize: 11 }}>
                                          · {ai.title}
                                        </span>
                                      ) : null}
                                    </span>
                                  </LightTooltip>
                                  <br />
                                </React.Fragment>
                              );
                            })}
                      </div>
                    </Card>
                  ))
                ) : (
                  // <Grid sx={{ minHeight: "375px" }}>
                  //   <Typography>No Category Present </Typography>
                  // </Grid>
                  <Grid container columns={{ xs: 3, sm: 8, md: 12 }} sx={{ minHeight: "420px" }}>
                    <Skeleton
                      variant="rectangular"
                      width={220}
                      height={285}
                      sx={{ mr: "10px", mt: "10px" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      width={220}
                      height={285}
                      sx={{ mr: "10px", mt: "10px" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      width={220}
                      height={285}
                      sx={{ mr: "10px", mt: "10px" }}
                    />
                    <Skeleton variant="rectangular" width={220} height={285} sx={{ mt: "10px" }} />
                  </Grid>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </>
    </>
  );
}

function Taxonomy() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AuthGuard>
          <TaxonomyOverview />
        </AuthGuard>
      </MDBox>
    </DashboardLayout>
  );
}

export default Taxonomy;
